<div class="scrollable-container" #scrollableContainer [class.mobile]="!windowService.isDesktopRes">
  <!-- The real grid stays display:none while 'pending' (the host page shows
       the calendar skeleton, driven by (readinessChange)), then appears
       instantly — no animation. -->
  <div [style.display]="entranceState === 'pending' ? 'none' : ''" [style.visibility]="isContentVisible ? 'visible' : 'hidden'">
    <div class="calendar">
      <div class="calendar-days">
        <div class="calendar-header fixed-header property-header" [class.mobile-width]="!windowService.isDesktopRes">
        </div>
        <!-- Track by day key: processedDaysOfWeek is rebuilt each ngOnChanges, so identity tracking would recreate (and re-animate) the header cells -->
        @for (dayData of processedDaysOfWeek; track trackByDayFn($index, dayData)) {
          <div
            class="calendar-header fixed-header"
            [class.today-column]="dayData.isToday">
            <div class="header-div">
              <div class="day-header-wrapper" [class.today-header]="dayData.isToday">
                @if (viewMode !== 'WEEK_MON_SUN') {
                  <tidy-text
                    [header]="dayData.translatedHeader"
                    class="day-from-week" />
                }
                @if (viewMode === 'WEEK_MON_SUN') {
                  <tidy-text
                    [header]="dayData.translatedHeader"
                    class="day-from-week" />
                }
              </div>
              <div class="sort-container">
                <tidy-image
                  [src]="'assets/icon/sort-up.png'"
                  [class.sort-enabled]="dayData.isSortEnabledAsc"
                  [class.sort-disabled]="dayData.isSortDisabledAsc"
                  (click)="sort(dayData.day, 'asc')" />
                <tidy-image
                  [src]="'assets/icon/sort-up.png'"
                  class="sort-down"
                  [class.sort-enabled]="dayData.isSortEnabledDesc"
                  [class.sort-disabled]="dayData.isSortDisabledDesc"
                  (click)="sort(dayData.day, 'desc')" />
              </div>
            </div>
          </div>
        }
        @for (property of paginatedProperties; track trackByPropertyFn($index, property)) {
          <div class="calendar-day property-col fixed-column"
            [class.mobile-width]="!windowService.isDesktopRes"
            [style.left]="fixedColumnLeft"
            [style.--house-color]="property.iconColor || null">
            <tidy-row class="vertical-align-middle">
              <tidy-tag
                [color]="property?.color"
                [addressId]="property?.id"
                style="margin-right: 5px" />
              @if (windowService.isDesktopRes) {
                <tidy-text
                  [clickableHeader]="property.displayName"
                  (action)="emitClickAction('property', property)"
                  [darkHover]="true" />
              }
              @if (!windowService.isDesktopRes) {
                <tidy-text
                  [clickableBody]="property.displayName"
                  (action)="emitClickAction('property', property)"
                  [darkHover]="true" />
              }
            </tidy-row>
            @if (property.nextReservationDate || property.nextJobDate || property.activePlans?.length || property.inquiriesLabel) {
              <div class="property-tree">
                @if (property.inquiriesLabel) {
                  <button
                    type="button"
                    class="property-tree-item property-tree-item--clickable property-tree-item--inquiries"
                    (click)="emitInquiriesClick(property)">
                    <span class="inquiries-callout">{{ property.inquiriesLabel }}</span>
                  </button>
                }
                @if (property.nextReservationDate) {
                  <div class="property-tree-item">
                    <span
                      class="property-tree-item-icon"
                      [style.-webkit-mask-image]="'url(assets/img/schedule.svg)'"
                      [style.mask-image]="'url(assets/img/schedule.svg)'"></span>
                    <div class="property-tree-item-body">
                      <div class="property-tree-item-title">
                        Next Check In: {{ property.formattedNextReservationDate }}{{ property.isNextReservationToday ? ' (Today)' : '' }}
                      </div>
                    </div>
                  </div>
                }
                @if (property.nextJobDate) {
                  <button
                    type="button"
                    class="property-tree-item property-tree-item--clickable"
                    (click)="emitClickAction('property', property)">
                    <span
                      class="property-tree-item-icon"
                      [style.-webkit-mask-image]="'url(assets/svg/briefcase.svg)'"
                      [style.mask-image]="'url(assets/svg/briefcase.svg)'"></span>
                    <div class="property-tree-item-body">
                      <div class="property-tree-item-title">
                        Next Job: {{ property.formattedNextJobDate }}{{ property.isNextJobToday ? ' (Today)' : '' }}
                      </div>
                    </div>
                  </button>
                }
                @for (plan of property.activePlans; track plan.id) {
                  <button
                    type="button"
                    class="property-tree-item property-tree-item--clickable"
                    (click)="emitPlanClick(property, plan)">
                    <span
                      class="property-tree-item-icon"
                      [style.-webkit-mask-image]="'url(assets/img/recurring.svg)'"
                      [style.mask-image]="'url(assets/img/recurring.svg)'"></span>
                    <div class="property-tree-item-body">
                      <div class="property-tree-item-title">{{ plan.formattedTitle }}</div>
                      @if (plan.frequencyLabel) {
                        <div class="property-tree-item-sub">{{ plan.frequencyLabel }}</div>
                      }
                      @if (plan.scheduleLabel) {
                        <div class="property-tree-item-sub">{{ plan.scheduleLabel }}</div>
                      }
                    </div>
                  </button>
                }
              </div>
            }
          </div>
          <!-- Simplified day cells - use pre-computed eventsByDay -->
          @for (dayData of processedDaysOfWeek; track trackByDayFn($index, dayData)) {
            <div
              (click)="goToBookjob(dayData.day, property)"
              [class]="dayData.calendarDayClasses + ' cell-highlight'"
              >
              <!-- All events for this day are pre-computed in eventsByDay -->
              @if (property.eventsByDay?.[dayData.day]; as dayEvents) {
                <!-- Reservations -->
                @for (reservation of dayEvents.reservations; track trackByFn($index, reservation)) {
                  <div
                    class="card-container"
                    [style]="reservation.cardStyle">
                    <app-reservation-card
                      [reservation]="reservation"
                      [address]="property?.displayName"
                      [addressId]="property?.id"
                      size="sm" />
                  </div>
                }
                <!-- Owner blocks - same lanes as reservations, quieter voice -->
                @for (block of dayEvents.ownerBlocks; track trackByFn($index, block)) {
                  <div
                    class="card-container"
                    [style]="block.cardStyle"
                    (click)="$event.stopPropagation()">
                    <app-owner-block-card
                      [block]="block"
                      [address]="property?.displayName"
                      size="sm" />
                  </div>
                }
                <!-- Jobs -->
                @for (job of dayEvents.jobs; track trackByFn($index, job)) {
                  @if (job?.skeleton) {
                    <tidy-card style="margin-bottom: 5px; left: -5px; padding: 0px; height: 60px">
                      <ion-skeleton-text animated style="width: 100%; height: 60px; border-radius: 6px; margin: 0;" />
                    </tidy-card>
                  }
                  @if (!job?.skeleton) {
                    <div
                      class="card-container job-card-container"
                      [style]="job.cardStyle"
                      (click)="emitClickAction('event', property, 'jobs', job)">
                      <tidy-card>
                        <div class="event-card-content job-card-content vertical-align-center">
                          <div>
                            <tidy-image [src]="job?.icon" />
                          </div>
                          @if (job?.isPrivate || job?.isJobRequest) {
                            <div>
                              @if (!job.isBeingAssigned) {
                                @if (job.showProAssignmentMenu) {
                                  <tidy-text
                                    class="no-wrap job-title"
                                    [clickableBody]="job.formattedTitle"
                                    mat-icon-button [matMenuTriggerFor]="assignProMenu" #assignProMenuTrigger="matMenuTrigger" (click)="showProMenu($event)" />
                                }
                                @if (!job.showProAssignmentMenu) {
                                  <tidy-text
                                    class="no-wrap job-title"
                                    [body]="job.formattedTitle" />
                                }
                              }
                              @if (job.isBeingAssigned) {
                                <ion-skeleton-text
                                  animated="true"
                                  style="width: 90px; height: 18px; margin-right: 20px; margin-top: -2px; margin-bottom: -2px" />
                              }
                              <mat-menu #assignProMenu="matMenu">
                                @for (pro of privatePros; track pro) {
                                  <button mat-menu-item (click)="assignPro(job, pro, $event)">
                                    {{pro?.name}}
                                  </button>
                                }
                              </mat-menu>
                            </div>
                          }
                          @if (!job?.isPrivate && !job?.isJobRequest) {
                            <div>
                              <tidy-text class="no-wrap job-title" [body]="job.formattedTitle" />
                            </div>
                          }
                        </div>
                        <div class="card-footer">
                          <div class="footer-content">
                            @if (!job?.isJobRequest) {
                              <div class="footer-text">
                                <tidy-text [body]="job?.time" />
                              </div>
                              <div class="footer-text align-center">
                                <tidy-text
                                  [ngStyle]="job.footerTextStyles"
                                  [body]="job.formattedStatusName" />
                                @if (job?.status?.icon_type == 'image') {
                                  <tidy-image
                                    [src]="job?.status?.icon"
                                    [class]="job?.status?.class + ' no-right-margin'"
                                    style="height: 15px; margin-left: 5px" />
                                }
                                @if (job?.status?.icon_type == 'initials') {
                                  <div
                                    [ngClass]="job?.status?.class"
                                    [ngStyle]="job.proInitialsStyles"
                                    [style.background]="job.avatarGradient"
                                    style="margin-left: 5px">
                                    {{job.homekeeperNameUppercase}}
                                  </div>
                                }
                              </div>
                            }
                            @if (job?.isJobRequest) {
                              <div class="footer-text">
                                @if (job.showDifferentDates) {
                                  <tidy-text
                                    [body]="job.formattedStartDate" />
                                  }<span>&nbsp;</span>
                                  <tidy-text [body]="job?.booking?.startTimeNoEarlierThan" /><span>&nbsp;</span>
                                  <tidy-text [body]="'-'" />
                                  @if (job.showDifferentDates) {
                                    <span>&nbsp;</span>
                                    <tidy-text [body]="job.formattedEndDate" />
                                    }<span>&nbsp;</span>
                                    <tidy-text [body]="job.truncatedEndTime" />
                                  </div>
                                  <div class="footer-text align-center">
                                    <tidy-text
                                      [ngStyle]="job.footerTextStyles"
                                      [body]="job.formattedStatusName" />
                                    @if (job?.status?.icon_type !== 'initials') {
                                      <tidy-image
                                        [src]="job?.status?.icon"
                                        class="no-right-margin"
                                        style="height: 15px; margin-left: 5px" />
                                    }
                                    @if (job?.status?.icon_type == 'initials') {
                                      <div
                                        [ngClass]="job?.status?.class"
                                        [ngStyle]="job.proInitialsStyles"
                                        [style.background]="job.avatarGradient"
                                        style="margin-left: 5px">
                                        {{job.statusInitialsUppercase}}
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                            </div>
                          </tidy-card>
                        </div>
                      }
                    }
                    <!-- Availability Requests -->
                    @for (request of dayEvents.availabilityRequests; track trackByFn($index, request)) {
                      <div
                        class="card-container job-card-container"
                        [style]="request.cardStyle"
                        (click)="emitClickAction('event', property, 'availabilityRequests', request)">
                        <tidy-card>
                          <div class="event-card-content job-card-content vertical-align-center">
                            <div>
                              <tidy-image [src]="request?.icon" />
                            </div>
                            <div>
                              <tidy-text class="no-wrap job-title" [body]="request.formattedTitle" />
                            </div>
                          </div>
                          <div class="card-footer">
                            @if (request.isInitiatedByHomekeeper) {
                              <div class="footer-text">
                                <tidy-row class="times-row-wrapper">
                                  <tidy-text [body]="request?.title" /><span>&nbsp;</span>
                                  <tidy-text [body]="'Proposed Other Times:'" />
                                </tidy-row>
                              </div>
                            }
                            <div class="footer-content">
                              <div class="footer-text">
                                <tidy-row class="times-row-wrapper extra-bottom-padding">
                                  @if (request.showAllTimeProposals) {
                                    <tidy-text
                                      [body]="request?.parsedRequestTimes" />
                                  }
                                  @if (!request.showAllTimeProposals) {
                                    <tidy-text
                                      [body]="request.parsedRequestTimesPreview" />
                                    }<br>
                                    @if (request.showViewAllTimesLink) {
                                      <tidy-text
                                        class="link"
                                        (click)="viewAllRequestTimes(request, $event)"
                                        [smallBody]="'View All Times'" />
                                    }
                                  </tidy-row>
                                </div>
                                @if (request.showAvailabilityStatus) {
                                  <div class="footer-text align-center">
                                    <tidy-text [body]="request.formattedStatusName" />
                                    <tidy-image
                                      [src]="request?.status?.icon"
                                      [ngClass]="(request?.status?.class ? request?.status?.class : '') + ' no-right-margin'"
                                      style="height: 15px; margin-left: 5px" />
                                  </div>
                                }
                              </div>
                            </div>
                          </tidy-card>
                        </div>
                      }
                    }
                    <div class="add-job-button">
                      <tidy-round-button
                        [buttonWidth]="25"
                        [imageWidth]="10"
                        class="green"
                        [image]="'assets/svg/add-heavy.svg'"
                        (action)="goToBookjob(dayData.day, property)" />
                    </div>
                  </div>
                }
              }
            </div> <!-- end of .calendar-days -->
          </div> <!-- end of .scrollable-container -->
          <div class="pagination-controls" style="display: flex; justify-content: center; margin: 15px 0 15px 0; margin-bottom: 10rem; width: 100%;">
            @if (hasPriorPage) {
              <tidy-small-button
                [text]="'Prior Page'"
                style="margin-right: 10px;"
                (buttonClick)="goToPriorPage()" />
            }
            @if (hasNextPage) {
              <tidy-small-button
                [text]="'Next Page'"
                (buttonClick)="goToNextPage()" />
            }
          </div>
        </div>
      </div>
